import { TableHead } from "@mui/material";
import React from "react";

export default function CustomTableHead({ children, className = "" }) {
	return <TableHead className={className}>{children}</TableHead>;
}
